import React from 'react';


function Footer() {

    return (
        <div className="footer">
            <p>© 2024 Nature Cam 🌎 By <a href="https://buymeacoffee.com/aaryamanpatel?utm_source=worldcam.vercel.app&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{textDecoration: "underline"}}>Aaryaman</a></p>
        </div>
    );
}

export default Footer;